import React, { Fragment } from "react";
import Header from "../../components/Header/Header";
import PageTitle from "../../components/pagetitle/PageTitle";
import Scrollbar from "../../components/scrollbar/scrollbar";
import Footer from "../../components/footer/Footer";
import PricingSection from "./PricingSection";
import SEO from "../../components/SEO/SEO";

const PricingPage: React.FC = () => {
  return (
    <Fragment>
      <SEO 
        title="TorqAI Pricing | Scalable AI Agency Plans" 
        description="View pricing for TorqAI's intelligent digital workers. Flexible plans starting from $199/month for Capro, Sapro, Vapro, and Hapro."
        canonicalUrl="https://torqai.ca/pricing"
      />
      <div className="about-page inner-page">
        <div className="body_wrap o-clip">
          <Header />
          <main>
            <PageTitle pageTitle="Pricing" pagesub="Pricing" />
            <PricingSection />
          </main>
          <Footer />
          <Scrollbar />
        </div>
      </div>
    </Fragment>
  );
};

export default PricingPage;
